import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: auto;
  display: ${({ displayMenu, displayFormInputs }) =>
    displayMenu && displayFormInputs ? 'flex' : 'none'};
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  margin: 0.5rem 0;

  @media (min-width: 62rem) {
    display: flex;
    justify-content: flex-start;
  }

  @media (min-width: 75rem) {
    width: fit-content;
  }
`;

export const Button = styled.button`
  width: 3rem;
  height: 3rem;
  position: relative;
  background-color: #1b7bdd;
  outline: none;
  border: none;
  margin: 0.5rem;

  .plus {
    height: 2.5rem;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    width: auto;
  }

  .search {
    height: 2rem;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: auto;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3rem;
    height: 3rem;
    transition: all 500ms;
  }

  &:hover {
    cursor: pointer;
    &:after {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 0.2rem;
    }
  }

  svg {
    height: 1.8rem;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    filter: invert(91%) sepia(100%) saturate(36%) hue-rotate(200deg) brightness(107%) contrast(99%);
  }
`;
